// Product page
document.addEventListener("DOMContentLoaded", function () {
    var swiper = new Swiper(".swiper-container-inner", {
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      loop: false,
      autoplay: {
        delay: 3000,
      },
    });
  });

// cart drawer
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[id^='recom-access-']").forEach(function (container) {
        var swiperContainer = container.querySelector(".swiper-container-inner");
        var nextButton = container.querySelector(".swiper-button-next");
        var prevButton = container.querySelector(".swiper-button-prev");

        if (swiperContainer && nextButton && prevButton) {
            new Swiper(swiperContainer, {
                slidesPerView: 1,
                spaceBetween: 20,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                loop: false,
                // autoplay: {
                //     delay: 3000,
                // },
            });
        }
    });
});

// cart page 

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.swiper-container').forEach(function (slider) {
        var sliderId = slider.getAttribute("id"); // Get unique ID
        var sliderIndex = sliderId.split('-')[1]; // Extract count1

        var swiper = new Swiper("#" + sliderId, {
            spaceBetween: 20,
            navigation: {
                nextEl: ".swiper-button-next-" + sliderIndex,
                prevEl: ".swiper-button-prev-" + sliderIndex,
            },
            loop: false,
            // autoplay: {
            //     delay: 3000,
            // },
            breakpoints: {
                767: { slidesPerView: 1, spaceBetween: 10 },
                768: { slidesPerView: 2, spaceBetween: 10 },
                1024: { slidesPerView: 3, spaceBetween: 10 }
            }
        });
    });
});

// accodian
var acc = document.getElementsByClassName("accordion");
var i;
for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
    this.classList.toggle("active");

    var panel = this.nextElementSibling;
    var plusIcon = this.querySelector(".plus");
    var minusIcon = this.querySelector(".minus");

    if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
        plusIcon.style.display = "block";  // Show plus icon when closed
        minusIcon.style.display = "none";   // Hide minus icon when closed
    } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
        plusIcon.style.display = "none";   // Hide plus icon when opened
        minusIcon.style.display = "block";  // Show minus icon when opened
    }
    });
}